import {ILayout, ILayoutRow} from '../_interface/layout';
import {IFullTemplateField} from '../_interface/itemplate-field';

export const addFieldsToLayout = (fields: IFullTemplateField[], layout: ILayout): ILayoutRow[] => {
	const rows = [...layout.rows];
	const reduced = fields.reduce((acc, curr) => {
		const templateFieldId = curr.templateFieldId;
		const found = rows.find(row => row.find(f => f.templateFieldId === templateFieldId));
		if (!found) {
			const size = fields.find(f => f.templateFieldId === templateFieldId).minSize;
			acc = [...acc, [{templateFieldId, size}]];
		}
		return acc;
	}, rows);

	return reduced;
};
